import { CurrencyInterfaceResponse } from '../interfaces/currency.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CurrencyModelResponse')
export class CurrencyModelResponse implements CurrencyInterfaceResponse {
  @JsonProperty('Code', String, true)
  code: string = undefined;

  @JsonProperty('ExchangeRate', Number, true)
  exchangeRate: number = undefined;
}
